import { Length, Matches } from 'class-validator';

import { passwordRegexp } from '@onArte/shared/regexp';

export class LoginByPasswordModel {
  @Length(3, 128)
  public login: string;

  @Length(8, 64)
  @Matches(passwordRegexp)
  public password: string;

  constructor(login: string, password: string) {
    this.login = login;
    this.password = password;
  }
}
